import { RootState } from 'store';
export const sel_snackbar = (state: RootState) => state.snackbar;
